<template>
  <div class="rightBar">
    <div id="barChart">
      <i @click="show_fzl_sel" class="el-icon-setting"
         style="position:relative;right: 0px;float: right;z-index: 101;width: 20%;top:9px">
      </i>
      <!-- height/width：显式传入，避免父级链路上某层高度未计算时 echarts 容器为 0 导致「看不见」 -->
      <LineChart
        id="fi"
        path="cal_fuzhenlv_drugs_of_dis"
        :key="fuzhenlv.sel_name"
        height="260px"
        width="100%"
        :params='{"diag":fuzhenlv.sel_name,"shengqu":selForm.sel_shengqu_zssy,"diban":selForm.sel_diban_zssy,"date_start":selForm.date_span_zssy[0],"date_end":selForm.date_span_zssy[1]}'
      ></LineChart>
    </div>

    <el-dialog title="" :visible.sync="dialogTableVisible" :modal="false">
      <div id="enlarge" style="width: 100%; height: 310px"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- append-to-body：挂到 body，避免大屏侧栏层叠导致 .v-modal 盖住 .el-dialog；z-index 高于顶栏下拉面等 -->
    <el-dialog
      title="选择条件"
      :visible.sync="fuzhenlvSelVisable"
      width="630px"
      append-to-body
      :z-index="6000"
      custom-class="rightbar-fuzhenlv-dialog"
      :close-on-click-modal="false"
    >

      <el-row :gutter="5">
        <el-col :span="4">
          <el-select v-model="fuzhenDialogForm.sel_shengqu_zssy" @change="onFuzhenDialogProvinceChange" placeholder="省区">
            <el-option v-for="item in options_province"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="fuzhenDialogForm.sel_diban_zssy" style="color: black" placeholder="全部" @change="fetchAllNamesFromDialogForm">
            <el-option v-for="item in options_city" :key="item.value" :label="item.label"  :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <el-date-picker
              v-model="fuzhenDialogForm.date_span_zssy"
              type="daterange"
              align="right" style="width:260px"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="fetchAllNamesFromDialogForm">
          </el-date-picker>
        </el-col>

        <el-col :span="6">
          <el-dropdown split-button style="background-color: #1f2f3d;" @click="change_shengqu">
                    <span style="color: black">
                      {{ fuzhenDialogDiag }}
                    </span>
            <el-dropdown-menu slot="dropdown">
              <template v-if="(fuzhenlv.all_names || []).length">
                <el-dropdown-item
                  v-for="(item, idx) in (fuzhenlv.all_names || [])"
                  :key="item.value || item.mr_diagnosis || idx"
                  class="sort-item"
                  @click.native="onFuzhenDialogPickDrug(item)"
                >
                  <span v-text="item.mr_diagnosis"></span>
                </el-dropdown-item>
              </template>
              <el-dropdown-item
                v-else
                disabled
                class="rightbar-fuzhenlv-dialog__empty"
              >
                暂无疾病数据，请调整省区/地办/日期或检查接口
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fuzhenlvSelVisable = false">取 消</el-button>
        <el-button type="primary" @click="confirmFuzhenDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import LineChart from "@/views/charts/line";

moment.tz("Asia/Shanghai");
export default {
  name: "rightBar",
  components: {
    LineChart
  },
  data() {
    return {
      dialogTableVisible: false,
      options_province: null,
      fuzhenlvSelVisable: false,
      options_city: false,
      fuzhenlv: {
        sel_name: '咳嗽',
        all_names: [],
      },
      selForm: {
        // date_span: [moment().subtract(21, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        date_span_zssy: [moment().subtract(7, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        sel_shengqu_zssy: '',
        sel_diban_zssy: '',
        date_span_jb: [moment().subtract(60, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      },
      /** 弹窗内编辑副本；确定前不写 selForm。疾病列表 all_names 在弹窗内随条件调用 fetchAllNamesFromDialogForm 更新 */
      fuzhenDialogForm: {
        sel_shengqu_zssy: '',
        sel_diban_zssy: '',
        date_span_zssy: [],
      },
      /** 弹窗内选中的疾病名，确定后写入 fuzhenlv.sel_name */
      fuzhenDialogDiag: '咳嗽',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime());
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            start.setHours(0, 0, 0, 0)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '全部',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3650);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  mounted() {
    this.get_province()
    this.request_fuzhenlv()
  },
  methods: {
    /**
     * 打开条件弹窗：拷贝当前筛选；疾病下拉随弹窗内条件用 fetchAllNamesFromDialogForm 刷新（与原先「改条件就拉列表」一致，不依赖点确定）
     */
    show_fzl_sel() {
      this.fuzhenDialogForm = {
        sel_shengqu_zssy: this.selForm.sel_shengqu_zssy,
        sel_diban_zssy: this.selForm.sel_diban_zssy,
        date_span_zssy: Array.isArray(this.selForm.date_span_zssy)
          ? [...this.selForm.date_span_zssy]
          : [moment().subtract(7, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      }
      this.fuzhenDialogDiag = this.fuzhenlv.sel_name
      this.fuzhenlvSelVisable = true
      this.$nextTick(() => {
        if (this.fuzhenDialogForm.sel_shengqu_zssy) {
          this.loadCitiesForForm(this.fuzhenDialogForm)
        }
        this.fetchAllNamesFromDialogForm()
      })
    },
    /**
     * 按省区拉取地办下拉数据（不清空地办），用于弹窗打开回填
     * @param {{ sel_shengqu_zssy: string }} form - 含省区 id
     */
    loadCitiesForForm(form) {
      if (!form || !form.sel_shengqu_zssy) {
        this.options_city = []
        return
      }
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_diban?province_id=" + form.sel_shengqu_zssy).then((res) => {
        this.options_city = res.data.data
      })
    },
    /**
     * 省区变更：清空地办并重新拉地市列表
     * @param {Object} [form] - 不传则使用 selForm（兼容旧用法）
     */
    get_city(form) {
      const target = form || this.selForm
      target.sel_diban_zssy = ''
      this.loadCitiesForForm(target)
    },
    /** 弹窗内切换省区：拉地市 + 按弹窗条件刷新疾病列表（不改页面 selForm） */
    onFuzhenDialogProvinceChange() {
      this.get_city(this.fuzhenDialogForm)
      this.fetchAllNamesFromDialogForm()
    },
    /** 弹窗内选择疾病，点确定后再写入 fuzhenlv 并刷新图表 */
    onFuzhenDialogPickDrug(item) {
      if (item && item.mr_diagnosis) {
        this.fuzhenDialogDiag = item.mr_diagnosis
      }
    },
    /**
     * 将弹窗条件写回页面并关闭；不调用 /cal_fuzhenlv。图表仅随 selForm/fuzhenlv.sel_name 变化由 LineChart 请求 cal_fuzhenlv_drugs_of_dis（一次业务查询）。
     */
    confirmFuzhenDialog() {
      if (!Array.isArray(this.fuzhenDialogForm.date_span_zssy) || this.fuzhenDialogForm.date_span_zssy.length < 2) {
        this.$message.warning('请选择日期范围')
        return
      }
      this.selForm.sel_shengqu_zssy = this.fuzhenDialogForm.sel_shengqu_zssy
      this.selForm.sel_diban_zssy = this.fuzhenDialogForm.sel_diban_zssy
      this.selForm.date_span_zssy = [...this.fuzhenDialogForm.date_span_zssy]
      this.fuzhenlv.sel_name = this.fuzhenDialogDiag
      this.fuzhenlvSelVisable = false
    },
    /**
     * 按弹窗内 fuzhenDialogForm 请求 /cal_fuzhenlv，只更新 fuzhenlv.all_names（疾病下拉），不改 selForm、不改 fuzhenlv.sel_name
     */
    fetchAllNamesFromDialogForm() {
      if (!Array.isArray(this.fuzhenDialogForm.date_span_zssy) || this.fuzhenDialogForm.date_span_zssy.length < 2) {
        return
      }
      const params = {
        shengqu: this.fuzhenDialogForm.sel_shengqu_zssy,
        diban: this.fuzhenDialogForm.sel_diban_zssy,
        date_start: this.fuzhenDialogForm.date_span_zssy[0],
        date_end: this.fuzhenDialogForm.date_span_zssy[1],
      }
      this.$http
        .post(process.env.VUE_APP_API_HOST + "/cal_fuzhenlv", params, { "content-type": "application/json" })
        .then((res) => {
          const raw = res.data && res.data.data
          console.log("fetchAllNamesFromDialogForm", raw)
          this.fuzhenlv.all_names = Array.isArray(raw) ? raw : []
        })
        .catch(() => {
          this.fuzhenlv.all_names = []
        })
    },
    get_province() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
        // this.options_province = res.data.data.filter(item => item.value != '')
        this.options_province = res.data.data
      })
    },
    change_shengqu(item) {
      this.$http.post(process.env.VUE_APP_API_HOST + "/get_shengqu_board", {"shengqu": item.value}, {"content-type": "application/json"}).then((res) => {
        this.shengqu_board_info = res.data.data
      })
    },
    request_fuzhenlv() {
      let params = {
        "shengqu": this.selForm.sel_shengqu_zssy,
        "diban": this.selForm.sel_diban_zssy,
        "date_start": this.selForm.date_span_zssy[0],
        "date_end": this.selForm.date_span_zssy[1]
      }
      this.$http.post(process.env.VUE_APP_API_HOST + "/cal_fuzhenlv", params, {"content-type": "application/json"}).then((res) => {
        const raw = res.data && res.data.data
        this.fuzhenlv.all_names = Array.isArray(raw) ? raw : []
        /**
         * 接口返回疾病列表后，为折线图选一个有效 diag（勿长期停留在「请选择」，否则 cal_fuzhenlv_drugs_of_dis 无数据像「没显示」）
         * @param {Array} list - 后端返回的疾病项列表
         */
        const list = this.fuzhenlv.all_names
        if (list.length > 0) {
          const hit = list.find((x) => x && x.mr_diagnosis === this.fuzhenlv.sel_name)
          if (!hit) {
            this.fuzhenlv.sel_name = list[0].mr_diagnosis
          }
        } else {
          this.fuzhenlv.sel_name = '咳嗽'
        }
      }).catch(() => {
        this.fuzhenlv.all_names = []
      })
    },
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  color: black;
}

::v-deep .el-dialog {
  background-color: #363944;
}

::v-deep .el-dialog__title {
  color: white;
}
.sort-item {
  display: inline-block;
  min-width: 110px;
  max-width: 200px;
  padding: 0 3px;
  margin: 10px 12px 2px 0;
  border-radius: 16px;
  line-height: 32px;
  font-size: 14px;
  color: #333333;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.04);
  cursor: pointer;
}

.rightBar {
  width: 100%;
  /* 与 LineChart 高度协调，保留标题与设置按钮空间 */
  min-height: 280px;
  height: auto;
  color: #fff;
  margin-top: 10px;
}

.rightBar #barChart {
  width: 100%;
  min-height: 260px;
}

</style>

<!-- append-to-body 后弹窗不在 .rightBar 作用域内，用 custom-class 单独着色 -->
<style lang="scss">
.rightbar-fuzhenlv-dialog {
  background-color: #363944;
}

.rightbar-fuzhenlv-dialog .el-dialog__title {
  color: #fff;
}

.rightbar-fuzhenlv-dialog__empty {
  padding: 12px 16px;
  font-size: 13px;
  color: #bbb;
}
</style>
